import { generateDynamicRoute } from '../utils/routeHelpers';
import { CTAButtonTransformer } from './ctaButtonTransformer';

// export const navBarTransformer = (allAvailableLocations: any, navLinkss: any, pageData: any) => {
//     const navLinks = [];
//     const {
//         datoCmsStorageTipsPage,
//         datoCmsUnitSizerPage,
//         datoCmsFaqPage,
//         datoCmsContactUsPage,
//         datoCmsUnitAvailabilityPage
//     } = pageData;
//     //Each link will have label , path and dataFrom

//     if (allAvailableLocations.length > 0) {
//         const homePageNavLink = {
//             label: 'Home Page',
//             link: '/',
//             dataFrom: ''
//         }
//         navLinks.push(homePageNavLink)
//     }

//     // Add faq page to the nav links
//     if (datoCmsFaqPage) {
//         const faqPageNavLink = {
//             label: 'Faq',
//             link: '/faq',
//             dataFrom: ''
//         }
//         navLinks.push(faqPageNavLink)
//     }

//     // Add contact us page to the nav links
//     if (datoCmsContactUsPage) {
//         const contactUsPageNavLink: any = {}
//         // Check of if a single location or multi-location site.
//         if (allAvailableLocations.length > 1) {
//             contactUsPageNavLink.label = 'Contact Us';
//             contactUsPageNavLink.link = '/select-location-page';
//             contactUsPageNavLink.dataFrom = 'contact-us'
//         } else {
//             const {
//                 locationState,
//                 locationCity
//             } = allAvailableLocations[0];
//             contactUsPageNavLink.label = 'Contact Us';
//             contactUsPageNavLink.link = generateDynamicRoute(locationCity, locationState, 'contact');
//             contactUsPageNavLink.dataFrom = 'contact-us'
//         }
//         navLinks.push(contactUsPageNavLink)
//     }

//     if (datoCmsUnitAvailabilityPage) {
//         const viewRatesPageLinks: any = {}
//         // Check of if a single location or multi-location site.
//         if (allAvailableLocations.length > 1) {
//             viewRatesPageLinks.label = 'View Rates';
//             viewRatesPageLinks.link = '/select-location-page';
//             viewRatesPageLinks.dataFrom = 'unit-availability'
//         } else {
//             const {
//                 locationState,
//                 locationCity
//             } = allAvailableLocations[0];
//             viewRatesPageLinks.label = 'View Rates';
//             viewRatesPageLinks.link = generateDynamicRoute(locationCity, locationState, 'view-rates');
//             viewRatesPageLinks.dataFrom = 'unit-availability'
//         }
//         navLinks.push(viewRatesPageLinks)
//     }

//     // Add unit sizer page to nav links
//     if (datoCmsUnitSizerPage) {
//         const unitSizerPageNavLink = {
//             label: 'Unit Sizer',
//             link: '/unit-sizer',
//             dataFrom: ''
//         };
//         navLinks.push(unitSizerPageNavLink);
//     }

//     // Add storage tips page to nav links
//     if (datoCmsStorageTipsPage) {
//         const storageTipsPageNavLink = {
//             label: 'Storage Tips',
//             link: '/storage-tips',
//             dataFrom: ''
//         }
//         navLinks.push(storageTipsPageNavLink)
//     }


//     return navLinks
// }


export const navBarTransformer = (allAvailableLocations: any, navLinksArray: any, pageData: any) => {
    const navLinks = [];
    const {
        datoCmsStorageTipsPage,
        datoCmsUnitSizerPage,
        datoCmsFaqPage,
        datoCmsContactUsPage,
        datoCmsUnitAvailabilityPage
    } = pageData;

    const hasMultipleLocations = allAvailableLocations.length > 1;

    const homePageNavLink = {
        label: 'Home',
        link: '/',
        dataFrom: ''
    }
    navLinks.push(homePageNavLink)

    // Iterate through the provided navLinkss array
    for (const navLink of navLinksArray) {
        const { href, text } = navLink;
        // Check if the href matches any predefined links
        switch (href) {
            case '/view-rates':
                if (datoCmsUnitAvailabilityPage) {
                    // Add the link if page data exists
                    if (allAvailableLocations.length > 1) {
                        const locationDropdown = {
                            label: 'Locations',
                            link: '/view-rates',
                            dataFrom: '',
                            subLinks: allAvailableLocations.map((location: any) => ({
                                label: location.locationCity,
                                link: generateDynamicRoute(
                                    location.locationCity,
                                    location.locationState,
                                    'view-rates'
                                ),
                                dataFrom: 'unit-availability'
                            }))
                        };
                        navLinks.push(locationDropdown);
                    } else {
                        const viewRatesLink = {
                            label: text,
                            link: hasMultipleLocations
                                ? '/select-location-page'
                                : generateDynamicRoute(
                                    allAvailableLocations[0].locationCity,
                                    allAvailableLocations[0].locationState,
                                    href.replace(/^\/|\/$/g, "")
                                ),
                            dataFrom: 'unit-availability'
                        };
                        navLinks.push(viewRatesLink);
                    }
                }
                break;
            case '/pay-rent':
                const cleanHref = href.replace(/^\/|\/$/g, "");
                const payRentLinks = {
                    label: text,
                    link: hasMultipleLocations
                        ? '/select-location-page'
                        : generateDynamicRoute(
                            allAvailableLocations[0].locationCity,
                            allAvailableLocations[0].locationState,
                            `${cleanHref}/payment`
                        ),
                    dataFrom: 'pay-rent'
                }
                navLinks.push(payRentLinks)
                break;
            case '/storage-tips':
                if (datoCmsStorageTipsPage) {
                    const storageTipsLink = {
                        label: text,
                        link: href,
                        dataFrom: ''
                    };
                    navLinks.push(storageTipsLink);
                }
                break;
            case '/unit-sizer':
                if (datoCmsUnitSizerPage) {
                    const unitSizerLinks = {
                        label: text,
                        link: href,
                        dataFrom: ''
                    }
                    navLinks.push(unitSizerLinks)
                }
                break;
            case '/contact':
                if (datoCmsContactUsPage) {
                    const contactUsLink = {
                        label: text,
                        link: hasMultipleLocations
                            ? '/select-location-page'
                            : generateDynamicRoute(
                                allAvailableLocations[0].locationCity,
                                allAvailableLocations[0].locationState,
                                href.replace(/^\/|\/$/g, "")
                            ),
                        dataFrom: 'contact-us'
                    };
                    navLinks.push(contactUsLink);
                }
                break;
            case '/faq':
                if (datoCmsFaqPage) {
                    const faqLinks = {
                        label: text,
                        link: href,
                        dataFrom: ''
                    }
                    navLinks.push(faqLinks)
                }
                break
            // Handle other links similarly if needed
        }
    }

    // ... (remaining code)

    return navLinks;
};

export const topBarTransformer = (allAvailableLocations: any, topBarData: any, facilityDetails: any) => {
    const topBarTransformerData: any = {};
    topBarTransformerData.variant = topBarData.variant;
    topBarTransformerData.mobileVariant = topBarData.mobileVariant;
    topBarTransformerData.contactDetails = contactDetailsTransformer(allAvailableLocations.locationContactDetails);
    topBarTransformerData.topBarConfig = { message: topBarData.message };
    topBarTransformerData.navbarNotice = topBarData.notice;
    topBarTransformerData.ctaConfig = CTAButtonTransformer(allAvailableLocations, topBarData.ctaButtonsConfig);
    topBarTransformerData.mapUrl = allAvailableLocations.googleMapsUrl;
    topBarTransformerData.socialMediaDetails = facilityDetails.datoCmsFacilityDetails.socialMediaDetails
    return topBarTransformerData;
}

export const contactDetailsTransformer = (contactDetails: any) => {
    return contactDetails.map((indivContact: any) => {
        return {
            textToDisplay: indivContact.textToDisplay,
            contactType: indivContact.contactType === 'Phone Number' ? 'Phone' : indivContact.contactType
        }
    })
};